export const UserUnlockedBox = ({ text }) => {
  return (
    <section className="UserUnlockedBox">
      <p className="MarginLeft20">{text}</p>
    </section>
  );
};
